import { Alert, Autocomplete, Box, Button, Card, Dropdown, IconButton, Input, Menu, MenuButton, MenuItem, Table, Typography } from '@mui/joy'
import React, { useState } from 'react'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { post, Token } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import MoreVert from '@mui/icons-material/MoreVert';
function Pflichtdateieneditor({upd, data}) {
    const [create, setcreate] = useState(false);
    const dateiarten = ["Pflichtdatei", "Konzeptdatei", "Empfehlungsdatei"];
    const zeiteinheit = ["Jahre", "Monate", "Wochen", "Tage"];
    const [createdateiart, setcreatedateiart] = useState(null);
    const [createdateiname, setcreatedateiname] = useState("");
    const [createzeiteinheit, setcreatezeiteinheit] = useState("");
    const [createzeitanzahl, setcreatezeitanzahl] = useState(0);
    const [a,seta] = useState(false);
    const navigate = useNavigate();

    function calculate() {
        if (isnull()){
          console.log("null");
          return;
        }
        let f = "add_pflicht_datei";
        if (createdateiart == "Konzeptdatei"){
           f = "add_konzept_pflichtdatei";
        }else if (createdateiart == "Empfehlungsdatei"){
           f = "add_empfehlungs_datei";
        }
        let a = 0;
        console.log(createzeitanzahl);
        if (createzeiteinheit == "Tage"){
          a = Number(createzeitanzahl);
        }else if(createzeiteinheit == "Wochen"){
          a = Number(createzeitanzahl) * 7;
        }else if(createzeiteinheit == "Monate"){
          a = Number(createzeitanzahl) * 30;
        }else if (createzeiteinheit == "Jahre"){
          a = Number(createzeitanzahl) * 365;
        }
        add(createdateiname, a, f); 

    }
    function isnull() {
      return [createdateiart, createdateiname, createzeiteinheit].some(value => value === null || value === "");
    }


    function add(name, days, fun){
        let body = {};
        body.token = Token.get();
        body.action = fun;
        body.target = Number(data.id);
        //body.overkath = overn;
        body.dateiname = name;
        body.days = Number(days);
        console.log(body);
        let response = post(body, "/vergleiche/sub-sparten");
        console.log(response);
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            upd();
            seta(true);
            setcreatedateiart(null);
            setcreatedateiname(null);
            setcreatezeiteinheit(null);
            setcreatezeitanzahl(0);
            setcreate(false);
        }else{
            alert("Fehler beim erstellen der pflichtdatei!");
        }
    }

    function remove(name, fun){
        let body = {};
        body.token = Token.get();
        body.action = fun;
        body.target = Number(data.id);
        //body.overkath = overn;
        body.dateiname = name;
        let response = post(body, "/vergleiche/sub-sparten");
        console.log(response);
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            upd();

        }else{
            alert("Fehler beim erstellen der pflichtdatei!");
        }
    }

    function formatDuration(ms) {
      const seconds = Math.floor(ms / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
    
      if (days < 1) {
        return "Niemals"; // Weniger als 1 Tag → String "Niemals"
      }
    
      const years = Math.floor(days / 365);
      days -= years * 365;
    
      const months = Math.floor(days / 30);
      days -= months * 30;
    
      const weeks = Math.floor(days / 7);
      days -= weeks * 7;
    
      const parts = [];
    
      if (years > 0) parts.push(`${years} Jahr${years > 1 ? 'e' : ''}`);
      if (months > 0) parts.push(`${months} Monat${months > 1 ? 'e' : ''}`);
      if (weeks > 0) parts.push(`${weeks} Woche${weeks > 1 ? 'n' : ''}`);
      if (days > 0) parts.push(`${days} Tag${days > 1 ? 'e' : ''}`);
    
      return parts.join(', ');
    }







  return (
    <>
            {
                a && (
                    <Alert
                    sx={{mb: 5}}
                    variant="soft"
                    color="success"
                    startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                    endDecorator={
                        <Button size="sm" variant="solid" color="success" onClick={() => seta(false)}>
                        Schliesen
                        </Button>
                    }
                    >
                    Ihre änderungen wurden Erfolgreich gespeichert.
                    </Alert>
                )
            }

            {
              create && (

                <Card variant='soft' sx={{mb: 5}}>
                <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                <Box sx={{display: "flex", flexDirection: "column", mb: 1}}>
                  <Typography level="title-md">Datei erstellen</Typography>
                  <Typography>Bitte geben sie alle nötigen informationen an</Typography>
                </Box>
                </Box>
                <Typography>Art der Datei:</Typography>
                <Autocomplete sx={{width: "25%", mb: 1}} options={dateiarten} onChange={(event, newval) => setcreatedateiart(newval)}/>
                <Typography>Dateiname:</Typography>
                <Input sx={{width: "25%", mb: 1}} onChange={(event) => setcreatedateiname(event.target.value)} placeholder='Dateiname'/>
                <Typography>Überprüfungszeitraum:</Typography>
                <Box sx={{display: "flex", flexDirection: "row", mb: 1}}>
                  <Input sx={{width: "7%"}} onChange={(event) => setcreatezeitanzahl(event.target.value)} type='number' placeholder='Anzahl' />
                  <Autocomplete sx={{ml: 1}} options={zeiteinheit} onChange={(event,newval) => setcreatezeiteinheit(newval)}/>
                </Box>
                <Button sx={{height: "5%",mt: 1, width: "10%"}}
                                  onClick={() => calculate()}
                                  startDecorator={<SaveOutlinedIcon/>}>Speichern</Button>
                </Card>
              )
            }




    <Card variant='soft' sx={{mb: 5}}>
      <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
      <Box sx={{display: "flex", flexDirection: "column"}}>
        <Typography level="title-md">Konzeptdateien</Typography>
        <Typography>Im Folgenden finden sie alle Konzept-Pflichtdateien aufgelistet. <br/> Diese Dateien erweitern die Pflichtdateien als solches</Typography>
      </Box>
      <Button sx={{height: "2%",mt: 1, width: "8%"}}
                              startDecorator={<AddBoxOutlinedIcon/>}
                              onClick={() => setcreate(true)}
                              >Hinzufügen</Button>
      </Box>

        <Table sx={{ '& thead th:nth-child(1)': { width: '50%' } }}>
            <thead>
                <tr>
                  <th>Dateiname</th>
                  <th>Überprüfungszeitraum</th>
                  <th>Bearbeiten</th>
                </tr>
                {Object.entries(data.kontextpflichtdateien).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{formatDuration(value)}</td>
                    <td>
                    <Dropdown>
                              
                        <MenuButton
                                slots={{ root: IconButton }}
                                slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                >
                                <MoreVert />
                                </MenuButton>
                                <Menu>
                                
                                <MenuItem sx={{color:"red"}} onClick={() => remove(key,"remove_konzeptdatei_pflichtdatei")} >Datei löschen</MenuItem>
                            </Menu>
                        </Dropdown>







                    </td>
                  </tr>
                ))}
            </thead>
      </Table>
      </Card>






    <Card variant='soft' sx={{mb: 5}}>
      <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
      <Box sx={{display: "flex", flexDirection: "column"}}>
        <Typography level="title-md">Empfehlungsdateien</Typography>
        <Typography>Im Folgenden finden sie alle Empfehlungs-Pflichtdateien aufgelistet. <br/> Diese Dateien erweitern die Pflichtdateien als solches</Typography>
      </Box>
      <Button sx={{height: "2%",mt: 1, width: "8%"}}
                              startDecorator={<AddBoxOutlinedIcon/>}
                              onClick={() => setcreate(true)}
                              >Hinzufügen</Button>
      </Box>

        <Table sx={{ '& thead th:nth-child(1)': { width: '50%' } }}>
            <thead>
                <tr>
                  <th>Dateiname</th>
                  <th>Überprüfungszeitraum</th>
                  <th>Bearbeiten</th>
                </tr>
            </thead>
            {Object.entries(data.empfelungspflichtdateien).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{formatDuration(value)}</td>
                    <td>
                    <Dropdown>
                              
                        <MenuButton
                                slots={{ root: IconButton }}
                                slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                >
                                <MoreVert />
                                </MenuButton>
                                <Menu>
                                
                                <MenuItem sx={{color:"red"}} onClick={() => remove(key,"remove_empfehlungs_datei")} >Datei löschen</MenuItem>
                            </Menu>
                        </Dropdown>

                    </td>
                  </tr>
                ))}
      </Table>
      </Card>

      <Card variant='soft' sx={{mb: 15}}>
      <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
      <Box sx={{display: "flex", flexDirection: "column"}}>
        <Typography level="title-md">Pflichtdateien</Typography>
        <Typography>Im Folgenden finden sie alle standartmäßigen Pflichtdateien aufgelistet. <br/> Diese gelten auch als grundlage für Konzept- und Empfehlungs-Tarife</Typography>
      </Box>
      <Button sx={{height: "2%",mt: 1, width: "8%"}}
                              startDecorator={<AddBoxOutlinedIcon/>}
                              onClick={() => setcreate(true)}
                              >Hinzufügen</Button>
      </Box>

        <Table sx={{ '& thead th:nth-child(1)': { width: '50%' } }}>
            <thead>
                <tr>
                  <th>Dateiname</th>
                  <th>Überprüfungszeitraum</th>
                  <th>Bearbeiten</th>
                </tr>
                {Object.entries(data.pflichtdateien).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{formatDuration(value)}</td>
                    <td>
                    <Dropdown>
                              
                        <MenuButton
                                slots={{ root: IconButton }}
                                slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                >
                                <MoreVert />
                                </MenuButton>
                                <Menu>
                                
                                <MenuItem sx={{color:"red"}} onClick={() => remove(key,"remove_pflicht_datei")} >Datei löschen</MenuItem>
                            </Menu>
                        </Dropdown>







                    </td>
                  </tr>
                ))}
            </thead>
      </Table>
      </Card>


    </>
  )
}

export default Pflichtdateieneditor
